export class clsUserInfo {
  corporate_name: string;
  postal_code: string;
  address: string;
  tel: string;
  business: string;
  person_charge: string;
  mail_address: string;
  password: string;
  checkPass: string;
  csrf: string;
  conf_flg: boolean;
  mail_backup: string;
  constructor() {
    this.corporate_name = ''
    this.postal_code = ''
    this.address = ''
    this.tel = ''
    this.business = ''
    this.person_charge = ''
    this.mail_address = ''
    this.password = ''
    this.checkPass = ''
    this.csrf = ''
    this.conf_flg = false
    this.mail_backup = ''
  }
  clear(): void {
    this.corporate_name = ''
    this.postal_code = ''
    this.address = ''
    this.tel = ''
    this.business = ''
    this.person_charge = ''
    this.mail_address = ''
    this.password = ''
    this.checkPass = ''
    this.csrf = ''
    this.conf_flg = false
    this.mail_backup = ''
  }
}